import { AdminAdDTOFields } from '../Types/dto/admin/product'
import { EventInput } from '@fullcalendar/core'

export function convertAdminAdToEventInputs(
	ads?: { [adId: string]: AdminAdDTOFields },
	adIdSelector?: string,
	isOnlyUserBookingVisible?: Boolean
): EventInput[] {
	const eventInputs: EventInput[] = []
	for (const [adId, ad] of Object.entries(ads ?? {})) {
		if (adIdSelector && adIdSelector != adId) {
			continue
		} else {
			const eventTimes = ad?.eventTimes ?? {}
			for (const [_eventTimeId, eventTime] of Object.entries(eventTimes)) {
				const start = new Date(eventTime?.startTime)
				const end = eventTime.endTime ? new Date(eventTime.endTime) : undefined
				const extendedProps = {
					enableSale: eventTime.enableSale,
					numOfParticipantsInOtherChannel:
						eventTime.numOfParticipantsInOtherChannel,
					additionalInfo: eventTime.additionalInfo,
					adId,
				}
				if (!isOnlyUserBookingVisible) {
					eventInputs.push({
						id: _eventTimeId,
						title: eventTime.additionalInfo ?? ad?.name ?? '',
						start,
						end,
						editable: true,
						extendedProps,
					})
				}
			}
		}
	}
	return eventInputs
}
